import { render } from "./GrapesJSRender.vue?vue&type=template&id=66019ac9"
import script from "./GrapesJSRender.vue?vue&type=script&lang=js"
export * from "./GrapesJSRender.vue?vue&type=script&lang=js"

import "./GrapesJSRender.vue?vue&type=style&index=0&id=66019ac9&lang=css"
script.render = render

export default script